module.exports = __webpack_public_path__ + "img/level_13_stellar.7b602b57.svg";